import React from 'react';
import style from './style.css';

export default class HelpMessage extends React.Component {
  render() {
    return (<React.Fragment>
      <p className={style['help-message']}>
        * Sequences with poor quality or sequences using source other than plasma can be deleted.
      </p>
      <p className={style['help-message']}>
        * Before reorganizing rows, please unfold all hidden columns.
      </p>
    </React.Fragment>);
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/help-message.js